<template>
  <div class="mission-custom-fields">
    <template v-for="customField in customFields">
      <v-text-field
        :id="customField.code"
        :value="getValue(customField.code)"
        :label="`${customField.name} ${
          required && customField.required ? '*' : ''
        }`"
        :key="customField.code"
        clearable
        dense
        v-bind="customField.props || {}"
        @input="(value) => setValue(customField.code, value)"
        v-if="customField.type === 'text' && isVisible(customField)"
      />
      <v-text-field
        :id="customField.code"
        :value="getValue(customField.code)"
        :label="`${customField.name} ${
          required && customField.required ? '*' : ''
        }`"
        :key="customField.code"
        clearable
        dense
        type="number"
        v-bind="customField.props || {}"
        @input="(value) => setValue(customField.code, value)"
        v-if="customField.type === 'number' && isVisible(customField)"
      />
      <v-select
        :id="customField.code"
        :value="getValue(customField.code)"
        :label="`${customField.name} ${
          required && customField.required ? '*' : ''
        }`"
        :items="customField.options || []"
        :key="customField.code"
        clearable
        dense
        v-bind="customField.props || {}"
        @input="(value) => setValue(customField.code, value)"
        v-if="customField.type === 'select' && isVisible(customField)"
      />
    </template>
  </div>
</template>

<script>
import { sortBy, get as object_get } from "lodash";
import { mapGetters } from "vuex";

export default {
  props: {
    mission: {},
    value: {},
    mode: {
      type: String,
      validator: (value) => {
        return ["form", "filter"].includes(value);
      },
      default: "form",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value_: {},
    rules: {
      required: (value) => !!value || "This field is required.",
    },
  }),
  computed: {
    ...mapGetters("config", ["getConfigByKey"]),
    customFields() {
      const fields = this.getConfigByKey("mission_custom_fields") || [];
      return sortBy(fields, ["sort"]);
    },
    weight_dry() {
      const weightEnd = parseFloat(
        this.value_.weight_end && this.value_.weight_end.value
          ? this.value_.weight_end.value
          : 0
      );
      const weightEmpty = parseFloat(
        this.value_.weight_empty && this.value_.weight_empty.value
          ? this.value_.weight_empty.value
          : 0
      );

      return (weightEnd - weightEmpty) * 0.73;
    },
    weight_result() {
      const weightDry = this.weight_dry;
      const assets = (this.mission && this.mission.missionAssets)
        ? this.mission.missionAssets
        : [];
      // [2021-07-14] We need to count "double" CPITs as two assets for this calculation
      let assetsCleanedTotal = 0;
      assets.forEach(missionAsset => {
        if (missionAsset.passFail === "pass") {
          let cpit_type;
          const q_and_a = Array.isArray(missionAsset.qa)
            ? missionAsset.qa
            : [];
          q_and_a.forEach(qa => {
            if (object_get(qa, 'code') == 'CPIT-0100') {
              cpit_type = object_get(qa, 'answers[0].code', '').toLowerCase();
            }
          });
          if (['double_cesspit', 'street_super_double'].includes(cpit_type)) {
            assetsCleanedTotal = assetsCleanedTotal + 2;
          }
          else assetsCleanedTotal++;
        }
      });
      let result = 0;
      // We use isFinite to handle NaN values in cases where parseFloat fails.
      if (isFinite(weightDry) && assetsCleanedTotal) {
        result = weightDry / assetsCleanedTotal;
      }
      return result.toFixed(2);
    },
  },
  created() {
    this.setInitialValues();
  },
  watch: {
    value(nextVal) {
      this.setInitialValues(Object.assign({}, nextVal));
    },
    mission(mission) {
      let data = mission.data || {};
      this.setInitialValues(data);
    },
    weight_dry(value) {
      this.setValue("weight_dry", value);
    },
    weight_result(value) {
      this.setValue("weight_result", value);
    },
  },
  methods: {
    setInitialValues(source) {
      source = (typeof source !== 'undefined') ? source : this.value;
      // First we need to make sure that local _value has all
      // necessary nodes or we could have trouble reacting
      // to nodes that are only added at a later stage.
      // (e.g. once known after an async ajax fetch)
      this.customFields.forEach((customField) => {
        this.$set(
          this.value_,
          customField.code,
          JSON.parse(JSON.stringify(customField))
        );
        const value =
          source && source[customField.code]
            ? source[customField.code].value
            : "";
        this.setValue(customField.code, value);
      });
    },
    getValueComputed(code) {
      let value = this[code];

      switch (typeof value) {
        case "number":
          value = value.toString();
          break;
      }

      return value || "";
    },
    getValue(code) {
      const value = this.value_[code] ? this.value_[code].value : "";
      const valueComputed = this.getValueComputed(code);

      return valueComputed || value;
    },
    setValue(code, value) {
      if (this.value_[code]) {
        this.$set(this.value_[code], "value", value);
        this.$emit("update:value", this.value_);
      }
    },
    isVisible(customField) {
      if (this.mode === "form") {
        return !customField.hidden;
      } else {
        return customField.filterable;
      }
    },
  },
};
</script>
